<template>
    <div>
        <el-tabs v-model="activeTabName">
            <el-tab-pane name="禁言管理">
                <span slot="label"><i class="el-icon-turn-off-microphone" style="margin-right: 5px"></i>禁言管理</span>
                <ChatBanPage/>
            </el-tab-pane>
            <el-tab-pane name="聊天历史">
                <span slot="label"><i class="el-icon-time" style="margin-right: 5px"></i>聊天历史</span>
                <ChatHistoryPage/>
            </el-tab-pane>
            <el-tab-pane name="禁言关键词">
                <span slot="label"><i class="el-icon-time" style="margin-right: 5px"></i>禁言关键词</span>
                <ChatBanKeywordPage v-if="activeTabName == '禁言关键词'" />
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
import ChatBanPage from "./ChatBanPage";
import ChatHistoryPage from "./ChatHistoryPage";
import ChatBanKeywordPage from "./ChatBanKeywordPage";

export default {
    data() {
        return {
            activeTabName: "禁言管理",
        };
    },

    components: {
        ChatBanPage,
        ChatHistoryPage,
        ChatBanKeywordPage,
    },
}
</script>